import logo from './img/logo.svg';
import main from './img/Home/main.jpg';

export const images = [
    logo,
    main
];